module.exports = __webpack_public_path__ + "img/offer_default.4f313e29.svg";